/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import ImageUploader from 'react-images-upload';
import {getImage} from '../../helpers/general';
import {px} from '../../utils';

const ImagePickerWeb = ({kidsImage, setSelectedImage}) => {
  const onDrop = (picture) => {
    setSelectedImage(picture);
  };

  return (
    <ImageUploader
      defaultImage={getImage(kidsImage)}
      withIcon={false}
      withLabel={false}
      buttonText="Change image"
      onChange={onDrop}
      imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg']}
      maxFileSize={10485760}
      singleImage={true}
      labelStyles={{
        fontFamily: 'Arial',
        fontSize: px(20),
        padding: px(15),
        textAlign: 'center',
      }}
      fileContainerStyle={{
        // ! disable change image
        display: 'none',
        // boxShadow: 'none',
        // margin: 0,
        // padding: 0,
      }}
      buttonStyles={{backgroundColor: 'rgb(249, 76, 42)'}}
    />
  );
};

export default ImagePickerWeb;
